import React from "react";
import { Box, Autocomplete, TextField } from "@mui/material";
import { useGetList, useInput } from "react-admin";

export const SelectBranchInput = ({ source, label, alwaysOn, disabled = false }) => {
  const { data: branches = [], isLoading } = useGetList("enterprise/branches", {
    filter: { status: true },
  });
  const {
    field: { value, onChange },
  } = useInput({ source });
  return (
    <Box sx={{ mb: 1 }}>
      <Autocomplete
        size="small"
        disabled={disabled}
        options={branches}
        getOptionLabel={(option) => option?.name || ""}
        value={branches.find((branch) => branch.id === value) || null}
        onChange={(event, newValue) => onChange(newValue ? newValue.id : "")}
        renderInput={(params) => (
          <TextField {...params} label={label || "Sucursal"} variant="outlined" disabled={isLoading || disabled} />
        )}
        sx={{ width: 200 }}
      />
    </Box>
  );
};
